// Tiny event bridge between the setup guide overlay and the pages it walks through.
// The guide listens for progress ('location-added', …); pages listen for requests
// from the guide ('open-plan-tab').

export type SetupGuideEvent =
  | 'location-added'
  | 'waypoint-added'
  | 'travel-info-saved'
  | 'open-plan-tab';

type Listener = () => void;

const listeners = new Map<SetupGuideEvent, Set<Listener>>();

export function onSetupGuideEvent(event: SetupGuideEvent, listener: Listener): () => void {
  const set = listeners.get(event) ?? new Set();
  set.add(listener);
  listeners.set(event, set);
  return () => { set.delete(listener); };
}

export function emitSetupGuideEvent(event: SetupGuideEvent): void {
  listeners.get(event)?.forEach((listener) => listener());
}
